import { ClickToCopy } from "@components/shared/ClickToCopy/ClickToCopy";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import { useAppContextNonNull } from "@contexts/AppContext";
import IOrderRecalculateTotalsDTO from "@models/DTO/IOrderRecalculateTotalsDTO";
import EndpointsEnum from "@models/EndpointsEnum";
import IOrder from "@models/IOrder";
import RestEndpointsEnum from "@models/RestEndpointsEnum";
import { buildRestUrl } from "@services/RestService";
import ky, { Options } from "ky";
import { ButtonGroup, Dropdown } from "react-bootstrap";

type Props = {
    order: IOrder;
};

export const AdminOrderActions = (props: Props) => {
    const { userModel, supplierModel, socket } = useAppContextNonNull();

    const recalculateTotals = () => {
        if (!props.order?.guid) {
            return;
        }

        const payload: IOrderRecalculateTotalsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            orderGuid: props.order?.guid,
            calculateTaxJar: false,
            skipClearTaxJar: false,
        };

        socket.emit(EndpointsEnum.OrderRecalculateTotals, payload);
    };

    /**
     * Get's the to emails for the order at the current workflow step.
     */
    const getToEmails = async () => {
        const options: Options = {
            headers: {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
            },
        };

        const url = buildRestUrl({
            endpoint: RestEndpointsEnum.AdminGetOrderToEmails,
            params: {
                orderGuid: props.order.guid,
            },
        });

        const response = await ky.get(url, options);

        console.log(`To Emails For Order: `, await response.json());
    };

    return (
        <div className={"AdminOrderActions"}>
            <div className={"d-flex align-items-center"}>
                <b>Order ID#</b>
                <ClickToCopy className={"ms-2"} noFlexGrow={true} text={(props.order?.id || "").toString()} />
            </div>
            <div className="mt-2">
                <Dropdown as={ButtonGroup} data-bs-theme="dark">
                    <Dropdown.Toggle size="sm" variant="primary">
                        <OwLabel title="order_actions" className="pointer" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => console.log(props.order)}>
                            <OwLabel title="console_order" className="pointer" />
                        </Dropdown.Item>
                        <Dropdown.Item onClick={recalculateTotals}>
                            <OwLabel title="recalculate_totals" className="pointer" />
                        </Dropdown.Item>
                        <Dropdown.Item onClick={getToEmails}>
                            <OwLabel title="get_to_emails" className="pointer" />
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
};
